(function () {
    'use strict';

    angular
        .module('directives.selectPerson', ['SelectPersonControllers'])
        .directive('selectPerson', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                modalTitle: '@',
                whenSelectedPerson: '&',
                filterPersons: '='
            },
            controller: ['$scope', '$modal', function ($scope, $modal) {

                $scope.selectPerson = function () {

                    // Modal to select person
                    var modalScope = $scope.$new(true);
                    modalScope.modalTitle = $scope.modalTitle;
                    modalScope.actualPersons = $scope.persons;
                    modalScope.excludePersons = $scope.filterPersons;

                    var selectPersonModal = $modal({
                        scope: modalScope,
                        template: require('./selectPersonModal.tpl.html'),
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        selectPersonModal.$promise.then(selectPersonModal.hide);
                    }

                    modalScope.okModal = function () {
                        modalScope.hideModal();
                    }

                    // Add the selected person
                    modalScope.whenSelectPerson = function (selectedPerson) {
                        $scope.whenSelectedPerson({ person: selectedPerson });
                        modalScope.okModal();
                    }

                    // Check if person is to be excluded
                    modalScope.isToExclude = function (person) {
                        var toExclude = false;
                        if (modalScope.excludePersons) {
                            modalScope.excludePersons.some(function (inList) {
                                if (person.ItemPersonID === inList.ItemPersonID) {
                                    toExclude = true;
                                    return true;
                                }
                                return false;
                            })
                        }

                        return toExclude;
                    }
                };
            }],
            link: function (scope, elem) {
                elem.bind('click', function () {
                    scope.selectPerson();
                });
            }
        }
    }
})();
